import * as React from 'react'
import * as st from './BeforePlayModal.module.scss'
import { Button } from '@amzn/dvui/dist/Button'
import { Modal } from '@amzn/dvui/dist/Modal'
import { StringMap, fillValues } from 'DVWebNodeUtils'
import { Milliseconds} from '../../../widgets/DVWebNodeSPA/utils/formatting'
import {
  DownloadStatusPayload,
  BeforePlayModals,
  ConstraintType
} from '../UWPNotifier'
import { triggerPlayback } from '../triggers'

interface BeforePlayModalProps {
  strings: StringMap
  downloadStatus: DownloadStatusPayload,
  modalRef: React.RefObject<Modal>
  showModalBeforePlay: BeforePlayModals
}

const ModalFooter = ({strings, downloadStatus, modalRef}: Omit<BeforePlayModalProps, 'showModalBeforePlay'>) => (
  <><Button onClick={(e: React.MouseEvent) => {
    e.preventDefault()
    triggerPlayback(downloadStatus.TitleId, downloadStatus.DownloadId)
    modalRef.current.close()
  }}>{strings.DV_WINAPP_PLAYMODAL_CTA}</Button><Button onClick={() => (modalRef.current.close())}>{strings.DV_WINAPP_PLAYMODAL_CANCEL}</Button></>
)

export const LicenseModal = ({strings, downloadStatus, modalRef, showModalBeforePlay}: BeforePlayModalProps) => (
  <Modal modalId={`lm-${downloadStatus.DownloadId || ''}-${downloadStatus.TitleId}`} className={st.confirmModal} ref={modalRef}
    footer={<ModalFooter {...({modalRef, downloadStatus, strings})} />}
    header={fillValues(strings.DV_WINAPP_PLAYMODAL_HEAD, { hours: String(new Milliseconds(showModalBeforePlay.TimeWindow).toHours()) })}>
      {fillValues(strings.DV_WINAPP_PLAYMODAL_DESC, { hours: String(new Milliseconds(showModalBeforePlay.TimeWindow).toHours()) })}
  </Modal>
)

export const RentalModal = ({strings, downloadStatus, modalRef, showModalBeforePlay}: BeforePlayModalProps) => (
  <Modal modalId={`rm-${downloadStatus.DownloadId || ''}-${downloadStatus.TitleId}`} className={st.confirmModal} ref={modalRef}
    footer={<ModalFooter {...({modalRef, downloadStatus, strings})} />}
    header={strings.DV_WINAPP_PLAYRENTALMODAL_HEAD}>
      <div className={st.rentalDesc}>
        {fillValues(strings.DV_WINAPP_PLAYRENTALMODAL_DESC, { hours: String(new Milliseconds(showModalBeforePlay.TimeWindow).toHours()) })} 
      </div>
      {strings.DV_WINAPP_PLAYRENTALMODAL_SUBDESC}
  </Modal>
)

export const BeforePlayModal = ({strings, downloadStatus, showModalBeforePlay, modalRef}: BeforePlayModalProps) => (
  <>
  {showModalBeforePlay && showModalBeforePlay.Type === ConstraintType.OFFLINE && (
    <LicenseModal
      showModalBeforePlay={showModalBeforePlay}
      strings={strings}
      downloadStatus={downloadStatus}
      modalRef={modalRef}
    />
  )}
  {showModalBeforePlay && showModalBeforePlay.Type === ConstraintType.RENTAL && (
    <RentalModal
      showModalBeforePlay={showModalBeforePlay}
      strings={strings}
      downloadStatus={downloadStatus}
      modalRef={modalRef}
    />
  )}
  </>
)

export const shouldOpenBeforePlayModal = (type: ConstraintType) => (
  type === ConstraintType.OFFLINE && !navigator.onLine || type === ConstraintType.RENTAL
)